export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/now-logo-06e0fc6563685a66896afba4a3b71b2a.png";